import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { Vehicle as VehicleModel } from 'models/vehicles';

const propTypes = {
  vehicle: PropTypes.instanceOf(VehicleModel).isRequired,
  deleteVehicle: PropTypes.func.isRequired,
  editVehicle: PropTypes.func.isRequired,
  setDefaultVehicle: PropTypes.func.isRequired,
  defaultVehicleId: PropTypes.number,
};

const defaultProps = {
  defaultVehicleId: null,
};

class Vehicle extends Component {
  constructor(props) {
    super(props);

    this.setAsDefault = this.setAsDefault.bind(this);
    this.deleteMethod = this.deleteMethod.bind(this);
    this.editMethod = this.editMethod.bind(this);
  }

  setAsDefault() {
    const { vehicle, setDefaultVehicle } = this.props;
    setDefaultVehicle(vehicle.id);
  }

  deleteMethod() {
    const { vehicle, deleteVehicle } = this.props;
    if (window.confirm(`Are you sure you want to delete this vehicle?`)) {
      deleteVehicle(vehicle.id);
    }
  }

  editMethod() {
    const { vehicle, editVehicle } = this.props;
    editVehicle(vehicle);
  }

  render() {
    const { vehicle, defaultVehicleId } = this.props;
    const isDefault = vehicle.id === defaultVehicleId;

    const defaultToggleClasses = cx({
      checkbox: true,
      selected: isDefault,
    });

    return (
      <div className="col-xs-12 col-md-4">
        <div className="heavy-shadowed">
          <div className="card-header">
            <div className={defaultToggleClasses} onClick={this.setAsDefault}>
              <label>{isDefault ? 'Default' : 'Set as default'}</label>
            </div>
          </div>
          <div className="card-body text-size-12 text-weight-medium text-color-dark-slate">
            <span className="iconified-font iconified-car display-inline-block padding-right-10" /> {vehicle.label}
            <div className="padding-top-10 text-weight-book">{vehicle.plateNumber}</div>
          </div>
          <div className="card-footer text-center">
            <div className="row">
              <div className="col-xs-6 clickable padding-left-2x padding-right-0 text-left" onClick={this.editMethod}>
                <span className="edit text-weight-medium clickable">EDIT</span>
              </div>
              <div className="col-xs-6 clickable" onClick={this.deleteMethod}>
                <span className="delete text-weight-medium clickable">DELETE</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Vehicle.propTypes = propTypes;
Vehicle.defaultProps = defaultProps;

export default Vehicle;

